import { createAsyncSaga } from '@wahaaabello/redux-async-actions';
import { Action } from 'redux-actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../../api';
import { FetchInvestmentPageDataParams } from '../../../api';
import { AnyObject } from '../../../types';
import investmentsActions from './actions';

function* fetchInvestment({ payload: id }: Action<string>) {
  try {
    const data = yield call(api.fetchInvestmentData, id);
    yield put(
      investmentsActions.fetchInvestmentSuccess({
        id,
        data
      })
    );
    return data;
  } catch (error) {
    yield put(investmentsActions.fetchInvestmentFailure(error));
    throw error;
  }
}

function* fetchInvestmentPage({
  payload: { id, loadtype, info, ...rest }
}: Action<AnyObject & { id: string; loadtype: string; info: any }>) {
  try {
    const data = yield call(api.fetchInvestmentPage, id, {
      loadtype,
      info,
      ...rest
    });
    yield put(
      investmentsActions.fetchInvestmentPageSuccess({
        id: `${loadtype}${info ? `-${info}` : ''}`,
        data
      })
    );
    return data;
  } catch (error) {
    yield put(investmentsActions.fetchInvestmentPageFailure(error));
    throw error;
  }
}

function* fetchInvestments(params: FetchInvestmentPageDataParams) {
  try {
    const pageData = yield call(api.fetchInvestmentPageData, params);
    yield put(
      investmentsActions.fetchInvestmentsSuccess({
        params,
        pageData
      })
    );
    return pageData;
  } catch (error) {
    yield put(investmentsActions.fetchInvestmentsFailure(error));
    throw error;
  }
}

function* fetchMyInvestments({ payload: { limit = 10 } }) {
  const params: FetchInvestmentPageDataParams = {
    page: 'self',
    listtype: 'active',
    searchtext: '',
    limit
  };
  return yield call(fetchInvestments, params);
}

function* fetchMyClosedInvestments({ payload: { limit = 10 } }) {
  const params: FetchInvestmentPageDataParams = {
    page: 'completed',
    listtype: 'closed',
    searchtext: '',
    limit
  };
  return yield call(fetchInvestments, params);
}

function* fetchInvestmentsByCategory({
  payload: { category = 'all', limit = 10 } = {}
}) {
  const params: FetchInvestmentPageDataParams = {
    page: 'explore',
    listtype: 'explorebycat',
    searchtext: category,
    limit
  };
  return yield call(fetchInvestments, params);
}

function* searchInvestments({ payload: { query = '', limit = 10 } = {} }) {
  const params: FetchInvestmentPageDataParams = {
    page: 'explore',
    listtype: 'searchlist',
    searchtext: query,
    limit
  };
  return yield call(fetchInvestments, params);
}

export default function* targetsSaga() {
  yield all([
    takeLatest(
      investmentsActions.fetchInvestmentRequest.toString(),
      createAsyncSaga(fetchInvestment)
    ),
    takeLatest(
      investmentsActions.fetchInvestmentPageRequest.toString(),
      createAsyncSaga(fetchInvestmentPage)
    ),
    takeLatest(
      investmentsActions.fetchMyInvestmentsRequest.toString(),
      createAsyncSaga(fetchMyInvestments)
    ),
    takeLatest(
      investmentsActions.fetchMyClosedInvestmentsRequest.toString(),
      createAsyncSaga(fetchMyClosedInvestments)
    ),
    takeLatest(
      investmentsActions.fetchInvestmentsByCategoryRequest.toString(),
      createAsyncSaga(fetchInvestmentsByCategory)
    ),
    takeLatest(
      investmentsActions.searchInvestmentsRequest.toString(),
      createAsyncSaga(searchInvestments)
    )
  ]);
}
